export const ONBOARDING_ATTEMPTS = {
    INITIAL: 'initial',
    REPEATED: 'repeated',
}

export const ONBOARDING_IMAGES_FOLDER = '/assets/onboarding';
